import { Flex, Text } from 'rebass';
import Icon from '../Icon/Icon';
import React from 'react';
import styled from '@emotion/styled';
import * as Accordion from '@radix-ui/react-accordion';

const StyledTimelineItemAccordionHeader = styled(Flex)`
  justify-content: space-between;
  position: sticky;
  top: 0;
  z-index: 1;
`;

const StyledAccordionHeader = styled(Accordion.Header)`
  all: unset;
  display: flex;
  flex: 1 1 auto;
`;

const StyledAccordionTrigger = styled(Accordion.Trigger)`
  all: unset;
  display: flex;
  width: 100%;
  justify-content: space-between;
  padding-right: 8px;
  padding-bottom: 8px;
  padding-top: 8px;

  &:hover {
    cursor: pointer;
  }

  svg {
    transition: transform 0.2s ease-in-out;
  }

  .radix--AccordionItem[data-state='open'] & {
    svg {
      transform: rotate(0deg);
    }
  }

  .radix--AccordionItem[data-state='closed'] & {
    svg {
      transform: rotate(-90deg);
    }
  }
`;

type TimelineItemAccordionHeaderProps = any & {
  year?: string;
  isFirst?: boolean;
  isLast?: boolean;
};

const TimelineItemAccordionHeader = (
  props: TimelineItemAccordionHeaderProps
) => {
  const { year, isFirst = true, isLast = true } = props;
  return (
    <StyledTimelineItemAccordionHeader
      bg="paneBg"
      justifyContent="space-between"
    >
      <StyledAccordionHeader>
        <StyledAccordionTrigger>
          <Text>{year}</Text>
          <Flex size={24} alignItems="center" justifyContent="center">
            <Icon icon="chevron-down" size="16" />
          </Flex>
          {/*<Text>{year}</Text>*/}
        </StyledAccordionTrigger>
      </StyledAccordionHeader>
    </StyledTimelineItemAccordionHeader>
  );
};

export default TimelineItemAccordionHeader;
